import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/app/app";
import { setAccessTokenProvider } from "@/auth/access-token-provider";
import { standaloneOidcAccessTokenProvider } from "@/auth/standalone-token-provider";
import { configureLocaleRuntime } from "@/locales/i18n";
import { initRequestClient } from "@/request";
import { prepareEmbeddedAppearance } from "@/surfaces/embedded/embedded-appearance";
import { embeddedAccessTokenProvider } from "@/surfaces/embedded/embedded-token-provider";
import { detectSurface } from "@/surfaces/surface";
import "@/global.css";

/**
 * 呈现面判定必须在 React 之前完成（嵌入设计 §9.3、AR-28）。
 *
 * 请求拦截器是模块加载期装配的模块级单例，路由渲染时再选 Provider 就晚了；
 * 共用一个 client 和认证拦截器，让并发 401 等待同一个续签 Promise。
 */
const surface = detectSurface();

if (surface === "embedded") {
  // 嵌入端的语言与主题完全受控于宿主：不读写 localStorage，也不跨标签同步（§5.5.3）。
  configureLocaleRuntime({ persist: false, syncAcrossTabs: false });
  prepareEmbeddedAppearance();
  setAccessTokenProvider(embeddedAccessTokenProvider);
} else {
  setAccessTokenProvider(standaloneOidcAccessTokenProvider);
}

// 拦截器要在任何组件发请求之前装好，且必须在 Provider 装配之后。
initRequestClient();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("找不到 #root，Tickbird Web 无法启动。");
}

// 首屏 loading 由 App 挂载后的 effect 淡出并移除：接入鉴权后启动要先跟 IAM 握手，
// 这里同步删掉会在跳转前露出一段白屏。
createRoot(rootElement).render(
  <StrictMode>
    <App surface={surface} />
  </StrictMode>,
);
